// src/components/Snackbar/NewImplementations/HooksAlerts/useServerAlert.js
import { useState, useCallback } from 'react'

const ANIM_DURATION = 300

export default function useServerAlert () {
  const [alertData, setAlertData] = useState(null)

  const onClose = useCallback(() => {
    setAlertData(null)
  }, [])

  const showAlert = useCallback(
    ({ variant, title, body, actions }) => {
      const payload = { variant, title, body, actions }
      // if already open, close then reopen after animation
      if (alertData) {
        setAlertData(null)
        setTimeout(() => setAlertData(payload), ANIM_DURATION + 50)
      } else {
        setAlertData(payload)
      }
    },
    [alertData]
  )

  // convenience for errors coming from authorize()
  const showError = useCallback(
    (title, body) =>
      showAlert({
        variant: 'error',
        title,
        body,
        actions: [{ label: 'Ok', onClick: onClose }]
      }),
    [showAlert, onClose]
  )

  return { alertData, showAlert, showError, onClose }
}
